import React from 'react';
import {VstButton} from 'vstui';
import {Dialog, Button} from '@vitalsource/vstui';
import Utils from '../utils/utils';
import TransactionAction from '../actions/transaction-action';

const RefundRestrictions = ({open, bulk, orderNumber}) => {

  const reasons = () => {
    if (bulk) {
      return (
        <ol>
          <li>{i18n.t('transactions.modal.cant-refund-5')}</li>
          <li>{i18n.t('transactions.modal.cant-refund-6')}</li>
        </ol>
      )
    } else {
      return (
        <ol>
          <li>{i18n.t('transactions.modal.cant-refund-1')}</li>
          <li>{i18n.t('transactions.modal.cant-refund-2')}</li>
          <li>{i18n.t('transactions.modal.cant-refund-3')}</li>
          <li>{i18n.t('transactions.modal.cant-refund-4')}</li>
        </ol>
      )
    }
  }


  const _hideModal = () => {
    TransactionAction.showDetails(orderNumber);
  }

  if (open) {
    return (
      <Dialog open onRequestClose={_hideModal} title={i18n.t('transactions.modal.cant-refund-title')} size="large">
        <div>
          <p>{i18n.t('transactions.modal.cant-refund')}</p>
          {reasons()}
          <p>{Utils.toHTML(i18n.t('transactions.modal.cant-refund-support', {brand: Mulligan.Brand.AccountCenter.brand, support_url: Mulligan.Brand.Support.url}))}</p>
          <div className="button-container">
            <Button onClick={_hideModal}>{i18n.t('base.close')}</Button>
          </div>
        </div>
      </Dialog>
    );
  } else {
    return null;
  }
}

RefundRestrictions.defaultProps = {
  open: false
}

export default RefundRestrictions;



/** WEBPACK FOOTER **
 ** ./src/js/components/refundRestrictions.jsx
 **/